import axios from "axios";
import React, { useEffect, useState } from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import CounselorProfilePage from "../CounselorProfilePage";
import ProfilePage from "../Profile/ProfilePage";
import { baseUrl } from "../../../helper/urls";
import { useSelector } from "react-redux";

const CounselorLayout = () => {
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true); // Loader state

  const [profileStatus, setProfileStatus] = useState([]);

  const viewProfileData = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${baseUrl}/api/counselors/getCounselorByToken`,
        { headers }
      );
      setProfileStatus(response.data.data);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    } finally {
      setLoading(false); // Stop loader regardless of success or error
    }
  };
  const activateBank = 1;
  useEffect(() => {
    viewProfileData();
  }, []);

  return (
    <MasterLayout>
      {/* <Breadcrumb title="Counselor Profile" /> */}
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "50vh",
          }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          {profileStatus.address == 1 &&
          profileStatus.document == 1 &&
          profileStatus.bank == 0 ? (
            <ProfilePage />
          ) : profileStatus.address == 0 &&
            profileStatus.document == 0 &&
            profileStatus.bank == 0 &&
            profileStatus.status == 0 ? (
            <CounselorProfilePage />
          ) : profileStatus.status == 1 || profileStatus.status == 3 ? (
            <ProfilePage />
          ) : (
            //  <CounselorProfilePage />
            <CounselorProfilePage />
          )}
        </>
      )}
    </MasterLayout>
  );
};

export default CounselorLayout;

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import MasterLayout from "../../../masterLayout/MasterLayout";
// import Breadcrumb from "../../../components/Breadcrumb";
// import CounselorProfilePage from "../CounselorProfilePage";
// import ProfilePage from "../Profile/ProfilePage";
// import { baseUrl } from "../../../helper/urls";

// const CounselorLayout = () => {
//   const { token } = useSelector((state) => state.auth);
//   const [profileStatus, setProfileStatus] = useState({});
//   const [loading, setLoading] = useState(true);

//   const viewProfileData = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/api/counselors/getCounselorByToken`,
//         { headers }
//       );
//       setProfileStatus(response.data.data);
//     } catch (error) {
//       console.error("Error fetching profile data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     viewProfileData();
//   }, []);

//   const isProfileIncomplete =
//     profileStatus.address !== 1 ||
//     profileStatus.document !== 1 ||
//     profileStatus.bank !== 1;

//   return (
//     <MasterLayout>
//       <Breadcrumb title="Counselor Profile" />
//       {loading ? (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             minHeight: "50vh",
//           }}
//         >
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       ) : isProfileIncomplete ? (
//         <CounselorProfilePage />
//       ) : (
//         <ProfilePage
//           activeTab={profileStatus.bank === 0 ? "bank" : "personal"}
//         />
//       )}
//     </MasterLayout>
//   );
// };

// export default CounselorLayout;

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import MasterLayout from "../../../masterLayout/MasterLayout";
// import Breadcrumb from "../../../components/Breadcrumb";
// import CounselorProfilePage from "../CounselorProfilePage";
// import ProfilePage from "../Profile/ProfilePage";
// import { baseUrl } from "../../../helper/urls";

// const CounselorLayout = () => {
//   const { token } = useSelector((state) => state.auth);
//   const [profileStatus, setProfileStatus] = useState("");
//   const [loading, setLoading] = useState(true); // Loader state

//   const viewProfileData = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/api/counselors/getCounselorByToken`,
//         { headers }
//       );
//       setProfileStatus(response.data.data);
//     } catch (error) {
//       console.error("Error fetching profile data:", error);
//     } finally {
//       setLoading(false); // Stop loader regardless of success or error
//     }
//   };

//   useEffect(() => {
//     viewProfileData();
//   }, []);
//   return (
//     <MasterLayout>
//       <Breadcrumb title="Counselor Profile" />
//       <CounselorProfilePage />
//       {loading ? (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             minHeight: "50vh", // Adjust height as needed
//           }}
//         >
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       ) : (
//         <>
//           {profileStatus.status == 1 ? (
//             <ProfilePage />
//           ) : (
//             <CounselorProfilePage />
//           )}
//         </>
//       )}
//     </MasterLayout>
//   );
// };

// export default CounselorLayout;

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import MasterLayout from "../../../masterLayout/MasterLayout";
// import Breadcrumb from "../../../components/Breadcrumb";
// import CounselorProfilePage from "../CounselorProfilePage";
// import ProfilePage from "../Profile/ProfilePage";
// import { baseUrl } from "../../../helper/urls";

// const CounselorLayout = () => {
//   const { token } = useSelector((state) => state.auth);
//   const [profileStatus, setProfileStatus] = useState("");

//   console.log(profileStatus, "profileStatus");

//   const viewProfileData = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/api/counselors/getCounselorByToken`,
//         { headers }
//       );

//       console.log(response.data, "dataaaaaaaaaaaa");
//       setProfileStatus(response.data.data);
//     } catch (error) {
//       console.error("Error fetching profile data:", error);
//     }
//   };

//   useEffect(() => {
//     viewProfileData();
//   }, []);

//   return (
//     <MasterLayout>
//       <Breadcrumb title="Counselor Profile" />
//       {profileStatus.status == 1 ? <ProfilePage /> : <CounselorProfilePage />}
//     </MasterLayout>
//   );
// };

// export default CounselorLayout;
